<template>
  <div class="container">
    <h1 class="h1">Block List</h1>
    <p>
      List of phone number prefixes, which are blocked for all customers.<br/>
      Blocking has first priority! AllowList and other mechanisms are second priority.<br/>
      <i>Admin Note: Blocked SMS have an entry in Outbox, except subscription is async over api-messaging-sms-entry.</i>
    </p>
    <div class="col-lg text-align-right margin-top-2 margin-bottom-2">
      <sdx-dialog
          v-bind:id="'block-modal'"
          label="Block Prefix"
          class="clearfix"
      >
        <sdx-dialog-toggle>
          <sdx-button
              id="addPrefix"
              data-testId="addPrefix"
              label="Add"
              class="sdx-button-object"
          />
        </sdx-dialog-toggle>
        <sdx-dialog-content>
          <div class="row">
            <div class="col margin-bottom-1">
              <sdx-input
                  name="Prefix"
                  label="Prefix"
                  class="sdx-input"
                  placeholder=""
                  :value="prefix"
                  @input="prefix=$event.target.value;prefixValidation()"
                  :validation-message="prefix!=='' && !validPrefix ? 'Prefix invalid': ''"
              >
              </sdx-input>
            </div>
          </div>
          <div class="row">
            <div class="col margin-bottom-1">
              <sdx-input
                  name="Comment"
                  label="Comment"
                  class="sdx-input"
                  placeholder="Comment (optional)"
                  :value="comment"
                  @input="comment=$event.target.value"
              >
              </sdx-input>
            </div>
          </div>
          <div class="row">
            <div class="col margin-top-2">
              <sdx-button-group>
                <sdx-button
                    label="Cancel"
                    @click="closeModal('block-modal')"
                    theme="secondary"
                ></sdx-button>
                <sdx-button
                    id="addPrefixModal"
                    data-testId="addPrefixModal"
                    label="Add"
                    @click="addPrefix()"
                    :disabled="!validPrefix"
                ></sdx-button>
              </sdx-button-group>
            </div>
          </div>
        </sdx-dialog-content>
      </sdx-dialog>
    </div>
    <sdx-loading-spinner id="spinner-blockedPrefix" ref="spinnerBlockList" size="large"
                         sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="blocked-prefix" ref="blockedPrefix">
      <div class="blocked-prefix-table table table--responsive table--highlight margin-top-2">
        <div class="table-wrapper">
          <br/>
          <table data-init="auto">
            <thead>
            <tr>
              <th class="table-header">Country</th>
              <th class="table-header">Prefix</th>
              <th class="table-header">Editor</th>
              <th class="table-header">Comment</th>
              <th class="table-header">CreatedOn</th>
              <th class="table-header">UpdatedOn</th>
              <th class="table-header text-align-center">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in blockedPrefix" v-bind:key="item">
              <td class="table-cell">
                <FlagComponent :country="item['destRegionCode']"/>
              </td>
              <td>{{ item.prefix }}</td>
              <td>{{ item.editor }}</td>
              <td>{{ item.comment }}</td>
              <td>{{ formatDate(item.createdOn) }}</td>
              <td>{{ formatDate(item.updatedOn) }}</td>
              <td>
                <div class="toolbar text-align-center" id="toolbar01">
                  <div class="toolbar__item item--show" style="padding-left: 5px">
                    <sdx-dialog
                        v-bind:id="'update-modal' + item.prefixBlockListId"
                        ref="updateModal"
                        :label="'Update Prefix: ' + item.prefix"
                        class="clearfix"
                    >
                      <sdx-dialog-toggle>
                        <button aria-label="Edit"
                                id="editActionButton"
                                @click="loadBlockedPrefix(item.prefixBlockListId)"
                        >
                          <i class="icon icon-edit" title="Edit"></i>
                        </button>
                      </sdx-dialog-toggle>
                      <sdx-dialog-content>
                        <div class="row">
                          <div class="col margin-bottom-1">
                            <sdx-input
                                name="Prefix"
                                label="Prefix"
                                class="sdx-input"
                                placeholder=""
                                type="number"
                                :value="prefix"
                                @input="prefix=$event.target.value;prefixValidation()"
                                :validation-message="!prefixValidation() ? 'Prefix invalid': ''"
                            ></sdx-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col margin-bottom-3">
                            <sdx-input
                                name="Comment"
                                label="Comment"
                                class="sdx-input"
                                placeholder="Comment (optional)"
                                :value="comment"
                                @input="comment=$event.target.value"
                            ></sdx-input>
                          </div>
                        </div>
                        <sdx-button-group>
                          <sdx-button
                              label="Cancel"
                              @click="closeModal('update-modal' + item.prefixBlockListId)"
                              theme="secondary"
                          ></sdx-button>
                          <sdx-button
                              label="Update"
                              @click="updateBlockedPrefix(item.prefixBlockListId)"
                              :disabled="!validPrefix"
                          ></sdx-button>
                        </sdx-button-group>
                      </sdx-dialog-content>
                    </sdx-dialog>

                  </div>
                  <div class="toolbar__item item--show" style="padding-left: 5px;">
                    <sdx-dialog
                        v-bind:id="'remove-modal' + item.prefixBlockListId"
                        label="Remove Prefix?"
                        icon-name="icon-bin"
                    >
                      <sdx-dialog-toggle>
                        <button aria-label="Remove"
                                id="removeActionButton">
                          <i class="icon icon-bin" title="Remove"></i>
                        </button>
                      </sdx-dialog-toggle>
                      <sdx-dialog-content>
                        <p>Do you really want to remove the prefix <strong>{{ item.prefix }}</strong> from the block
                          list?</p>
                        <sdx-button-group>
                          <sdx-button
                              label="NO"
                              @click="closeModal('remove-modal' + item.prefixBlockListId)"
                              theme="secondary"
                          ></sdx-button>
                          <sdx-button
                              label="Yes"
                              @click="deleteBlockedPrefix(item.prefixBlockListId)"
                          ></sdx-button>
                        </sdx-button-group>
                      </sdx-dialog-content>
                    </sdx-dialog>

                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="col-xs">
          <div v-if="totalPages != 1" class="sms-outbox-pagination">
            <div v-bind:current-page="currentPage.number + 1" v-bind:total-pages="Math.ceil(totalElements / size)"
                 @pageChanged="search">
              <ul v-if="totalPages > 0" class="pagination">
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label="<<"
                      class="sdx-button"
                      @click="gotoPage(1)"
                      :disabled="isFirstPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label="<"
                      class="sdx-button"
                      @click="gotoPage(currentPage - 1)"
                      :disabled="isFirstPage"/>
                </li>
                <li v-for="page in pages" v-bind:key="page" class="pagination-item">
                      <span
                          v-if="page.placeholder"
                          class="pagination-button inactive"
                      >
                        ...
                      </span>
                  <button
                      v-else
                      type="button"
                      class="pagination-button"
                      @click="gotoPage(page.pageNumber)"
                      :class="`${page.currentPage ? 'active' : 'inactive'}`"
                  >
                    {{ page.pageNumber }}
                  </button>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label=">"
                      class="sdx-button"
                      @click="gotoPage(currentPage + 1)"
                      :disabled="isLastPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label=">>"
                      class="sdx-button"
                      @click="gotoPage(totalPages)"
                      :disabled="isLastPage"/>
                </li>
                <li class="pagination-item total-elements">
                  Total: {{ this.totalElements }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blockedPrefixService from '../service'
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";
import userService from "@/services/user.service";
import FlagComponent from "@/components/FlagComponent";
import {showAlert, showSuccess} from "@/services/notification.service";
import {formatDate, validatePrefix} from "@/util/utility";

export default {
  components: {
    FlagComponent,
  },
  data: function () {
    return {
      auditLogs: [],
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showBlockListTable: false,
      isAdmin: false,
      prefix: '',
      selectedPrefix: '',
      validPrefix: false,
      comment: '',
    }
  },
  computed: {
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null

      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },
  },
  mounted() {
    this.loadBlockList()
  },
  methods: {
    formatDate,
    loadBlockList: async function (page) {
      try {
        loadingSpinnerService.showByRef(this.$refs.spinnerBlockList, this.$refs.auditLogs)
        let response = await blockedPrefixService.getBlockList(page - 1, 10, "prefix");
        this.blockedPrefix = response.data.content;
        this.totalPages = response.data.totalPages;
        this.pageNumber = response.data.pageNumber;
        this.currentPage = response.data.number + 1;
        this.totalElements = response.data.totalElements;
        this.size = response.data.size;
        this.showBlockListTable = true;
        loadingSpinnerService.hideByRef(this.$refs.spinnerBlockList, this.$refs.auditLogs)
      } catch (error) {
        this.blockedPrefix = []
        showAlert(error.message)
      }
    },
    loadBlockedPrefix: async function (prefixId) {
      try {
        logger.debug("try");
        let response = await blockedPrefixService.getBlockedPrefix(prefixId);
        this.prefix = response.data.prefix;
        this.comment = response.data.comment || '';
        logger.debug("load prefix: " + this.prefix)
        logger.debug(JSON.stringify(this.prefix))
      } catch (error) {
        this.prefix = []
        this.comment = ''
        showAlert(error.message)
      }
    },
    handlePrefixSelected(selectedPrefix) {
      this.selectedPrefix = selectedPrefix;
      logger.debug("SelectedPrefix: " + this.selectedPrefix);
    },
    addPrefix: async function () {
      try {
        let user = await userService.getLoggedInUser();
        let blockedPrefix = this.selectedPrefix + this.prefix;
        await blockedPrefixService.addBlockedPrefix(blockedPrefix, user.name, this.comment);
        this.closeModal('block-modal');
        this.loadBlockList();
        showSuccess('Prefix is blocked successfully!');

      } catch (exception) {
        this.closeModal('block-modal');
        showAlert("Could not block Prefix! " + exception.response.data);
      }
    },
    updateBlockedPrefix: async function (prefixId) {
      try {
        let user = await userService.getLoggedInUser();
        logger.debug("prefix: " + this.prefix)
        await blockedPrefixService.updateBlockedPrefix(prefixId, this.prefix, this.comment, user.name,);
        this.closeModal('update-modal' + prefixId);
        this.loadBlockList();
        showSuccess('Prefix is updated successfully!');
      } catch (exception) {
        this.closeModal('update-modal' + prefixId);
        showAlert("Could not update Prefix! " + JSON.stringify(exception.response.data.detail));
      }
    },
    deleteBlockedPrefix: async function (prefixId) {
      try {
        await blockedPrefixService.deleteBlockedPrefix(prefixId);
        this.closeModal('remove-modal' + prefixId);
        this.loadBlockList();
        showSuccess('Prefix is unblocked successfully!')
      } catch (exception) {
        this.closeModal('remove-modal' + prefixId);
        showAlert("Prefix could not unblock!")
      }
    },
    prefixValidation() {
      return this.validPrefix = validatePrefix(this.prefix);
    },
    gotoPage: function (page) {
      this.loadBlockList(page);
      this.$emit('pageChanged', page);
    },
    closeModal: function (elementId) {
      if (this.prefix !== '') {
        this.prefix = '';
      }
      if (this.comment !== '') {
        this.comment = '';
      }
      document.getElementById(elementId)
          .close()
      setTimeout(() => {
        this.exportError = null
      }, 150)
    },
    watch: {
      page: function () {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style>


.blocked-prefix-table .table-header {
  padding-top: 20px;
  padding-bottom: 17px;
}

.blocked-prefix-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
}

.blocked-prefix-table .table-cell {
  border-radius: 20px;
}

.blocked-prefix-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}
</style>